import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ElementRef,
  ViewChild,
  Inject,
  PLATFORM_ID,
  OnDestroy,
} from "@angular/core";
import { timer, Subject, Subscription, BehaviorSubject } from "rxjs";
import { startWith, switchMap } from "rxjs/operators";
import {
  enterAnimation,
  fadeAnimation,
} from "../../../@core/functions/animations";
import { TestimonialsInterface } from "../../../@core/models/site-material-data.model";
import { TestimonialModel } from "../../../@core/models/testimonial.model";
import { isPlatformBrowser } from "@angular/common";
import { DataService } from "src/app/@core/services/data.service";
import { FontsService } from "src/app/@core/services/fonts.service";

@Component({
  selector: "app-testimonials",
  templateUrl: "./testimonials.component.html",
  styleUrls: ["./testimonials.component.scss"],
  animations: [enterAnimation, fadeAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialTestimonialsComponent implements OnInit, OnDestroy {
  testimonials: TestimonialModel[];
  title: string;
  subTitle: string;
  titleSize: string;
  titleColor: string;
  textColor: string;
  fontWeight: string;
  subTitleColor: string;
  backgroundColor: string;
  titleInputValue: string;
  activatePadding: boolean = false;
  // public currentTestimonialSlider = 0;
  public currentTestimonialSlider$: BehaviorSubject<number> =
    new BehaviorSubject<number>(0);
  private testimonialLength: number;
  private reset$ = new Subject();
  subscription: Subscription;
  data: TestimonialsInterface;
  active: boolean = false;
  position: number = 0;
  moduleInfo: string;
  loading: boolean = true;
  allElementAnimation: string;
  textAnimation: string;
  itemsAnimation: string;
  colorBullet: string;
  titleFontFamily: string;
  titleFontFamilyName: string;
  shape: string;
  @ViewChild("titleInput", { static: false }) titleInputEl: ElementRef;

  constructor(
    @Inject(PLATFORM_ID) public platformId,
    private dataService: DataService,
    private fontsService:FontsService
  ) {}

  ngOnInit() {
    if (this.data.animation) {
      this.allElementAnimation =
        this.data.animation.allElement != ""
          ? this.data.animation.allElement
          : undefined;
      this.textAnimation =
        this.data.animation.text != "" ? this.data.animation.text : undefined;
      this.itemsAnimation =
        this.data.animation.items != "" ? this.data.animation.items : undefined;
    }
    this.loading = false;
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.initializeTimer();
    this.title = this.data.title;
    this.subTitle = this.data.subTitle;
    this.titleSize = this.data.titleSize ? this.data.titleSize : "";
    this.titleSize = this.data.titleSize ? this.data.titleSize : "";
    this.fontWeight = this.data.fontWeight ? this.data.fontWeight : "";
    this.subTitleColor = this.data.subTitleColor;
    this.testimonials = this.data.groupe;
    this.shape = this.data.shape ? this.data.shape : '';
    this.titleFontFamily = this.data.titleFontFamily ? this.data.titleFontFamily : '';
    this.backgroundColor = this.data.backgroundColor
      ? this.data.backgroundColor
      : "";
    this.titleColor = this.data.titleColor
      ? this.data.titleColor
      : this.data.textColor;
    this.textColor = this.data.textColor
      ? this.data.textColor
      : this.dataService.getDefaultColor(this.backgroundColor);
    this.colorBullet = this.dataService.getDefaultColor(this.backgroundColor);
    if(this.titleFontFamily){
      this.fontsService.AddFont(this.titleFontFamily);
      this.titleFontFamilyName = this.titleFontFamily.replace(/\+/g, " ")
    }
  }
  // Slideshow Functions -------------------------------------------------
  // Timer for Slideshow
  initializeTimer(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.subscription = this.subscription = this.reset$
        .pipe(
          startWith(void 0),
          switchMap(() => timer(5000))
        )
        .subscribe(() => {
          this.nextSliderClick();
          this.refreshTimer();
        });
    }
  }
  // Refresh timer for Slideshow
  refreshTimer(): void {
    this.reset$.next(void 0);
  }
  // Controller for Slideshow
  nextSliderClick(destination?: number) {
    this.refreshTimer();
    if (this.testimonials) {
      this.testimonialLength = this.testimonials.length - 1;
    } else {
      this.testimonialLength = 2;
    }

    if (destination && destination <= this.testimonialLength) {
      this.currentTestimonialSlider$.next(destination);
    } else if (
      this.currentTestimonialSlider$.getValue() < this.testimonialLength
    ) {
      this.currentTestimonialSlider$.next(
        this.currentTestimonialSlider$.getValue() + 1
      );
    } else {
      this.currentTestimonialSlider$.next(0);
    }
  }

  updateUrl($event) {
    if (isPlatformBrowser(this.platformId)) {
      const src = $event.target.src;
      $event.target.src =
        "https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/gallery/loading.gif";
      setTimeout(() => {
        $event.target.src = src;
      }, 8000);
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
